export interface BusinessTopic {
  id: string
  name: string
  category: string  // 业务分类，对应左侧目录
  subCategory?: string // 子目录，仅零售业务使用
  department: string
  description: string
  catalogId: string // 关联的 catalog-detail 页面
  tableCount: number
  recordCount: string
  updateFrequency: string
  keywords?: string[]
}

export const BUSINESS_TOPICS: BusinessTopic[] = [
  {
    id: 'topic-payroll',
    name: '代发客群资金交易明细主题',
    category: '零售业务',
    subCategory: '个人存款',
    department: '零售金融部',
    description: '代发客户工资流水、余额变动、资金留存等交易明细分析',
    catalogId: 'retail-customer',
    tableCount: 3,
    recordCount: '80 万+',
    updateFrequency: 'T+1',
    keywords: ['代发', '客群', '资金', '交易', '流水', '余额', '存款余额', '工资', '留存'],
  },
  {
    id: 'topic-corp-deposit',
    name: '对公大额存款变动情况',
    category: '对公业务',
    subCategory: '存款产品',
    department: '公司金融部',
    description: '对公客户大额存款余额变动日报，支持按客户、机构、管户经理维度分析',
    catalogId: 'retail-deposit',
    tableCount: 6,
    recordCount: '35 万+',
    updateFrequency: 'T+1',
    keywords: ['对公', '大额', '存款', '余额', '存款余额', '变动', '日报'],
  },
  {
    id: 'topic-retail-1',
    name: '零售客户信息',
    category: '零售业务',
    subCategory: '其他',
    department: '零售金融部',
    description: '零售板块客户基础信息，包含客户身份、联系方式、风险等级等',
    catalogId: 'retail-customer',
    tableCount: 5,
    recordCount: '120 万+',
    updateFrequency: 'T+1',
    keywords: ['零售', '客户', '信息', '身份', '联系', '风险等级'],
  },
  {
    id: 'topic-retail-3',
    name: '零售存款业务分析',
    category: '零售业务',
    subCategory: '个人存款',
    department: '零售金融部',
    description: '存款规模、结构、利率变动趋势分析，支持按期限、币种筛选',
    catalogId: 'retail-deposit',
    tableCount: 4,
    recordCount: '150 万+',
    updateFrequency: 'T+1',
    keywords: ['零售', '存款', '余额', '存款余额', '规模', '结构', '利率', '趋势'],
  },
  {
    id: 'topic-corp-1',
    name: '对公存款信息',
    category: '对公业务',
    subCategory: '存款产品',
    department: '公司金融部',
    description: '对公客户存款账户余额、变动、利率等核心指标',
    catalogId: 'retail-deposit',
    tableCount: 6,
    recordCount: '35 万+',
    updateFrequency: 'T+1',
    keywords: ['对公', '存款', '余额', '存款余额', '账户', '变动', '利率'],
  },
  {
    id: 'topic-corp-2',
    name: '对公客户画像分析',
    category: '对公业务',
    subCategory: '其他',
    department: '公司金融部',
    description: '构建企业客户多维画像，支持精准营销和授信评估',
    catalogId: 'corporate-customer',
    tableCount: 8,
    recordCount: '12 万+',
    updateFrequency: 'T+1',
    keywords: ['对公', '客户', '画像', '营销', '授信'],
  },
  {
    id: 'topic-market-1',
    name: '金融市场业务分析',
    category: '金融市场',
    subCategory: '金融市场业务',
    department: '金融市场部',
    description: '同业业务、债券投资、回购交易等金融市场数据分析',
    catalogId: 'market-bond',
    tableCount: 7,
    recordCount: '50 万+',
    updateFrequency: 'T+1',
    keywords: ['金融', '市场', '同业', '债券', '投资', '回购', '交易'],
  },
  {
    id: 'topic-risk-1',
    name: '风险资产分类统计',
    category: '风险合规',
    department: '风险管理部',
    description: '统计全行风险资产五级分类情况，用于监管报送和内部风险管理',
    catalogId: 'risk-classification',
    tableCount: 4,
    recordCount: '20 万+',
    updateFrequency: 'T+1',
    keywords: ['风险', '资产', '分类', '五级分类', '管理', '贷款余额', '贷款金额'],
  },
  {
    id: 'topic-risk-2',
    name: '授信业务明细',
    category: '风险合规',
    department: '风险管理部',
    description: '全行授信业务借据级别明细数据，含客户、金额、期限、担保方式等',
    catalogId: 'risk-credit',
    tableCount: 9,
    recordCount: '45 万+',
    updateFrequency: 'T+1',
    keywords: ['授信', '业务', '风险', '管理', '贷款金额', '贷款余额'],
  },
  {
    id: 'topic-finance-1',
    name: '分支行考核指标',
    category: '财务会计',
    department: '计划财务部',
    description: '各分支机构存贷款、中间业务、利润完成情况考核指标',
    catalogId: 'branch-personal',
    tableCount: 5,
    recordCount: '5 万+',
    updateFrequency: 'T+1',
    keywords: ['分支行', '考核', '指标', '存贷款', '中间业务', '利润'],
  },
  {
    id: 'topic-ops-1',
    name: '网点效能分析',
    category: '运营管理',
    department: '渠道管理部',
    description: '各网点业务办理量、客户满意度、人员效率统计分析',
    catalogId: 'branch-personal',
    tableCount: 3,
    recordCount: '8 万+',
    updateFrequency: 'T+1',
    keywords: ['网点', '效能', '业务', '满意度', '效率'],
  },
  {
    id: 'topic-ops-2',
    name: '运营流程优化分析',
    category: '运营管理',
    department: '运营管理部',
    description: '业务流程节点效率分析、瓶颈识别、优化建议',
    catalogId: 'branch-personal',
    tableCount: 4,
    recordCount: '10 万+',
    updateFrequency: 'T+1',
    keywords: ['运营', '流程', '效率', '瓶颈', '优化'],
  },
  {
    id: 'topic-corp-branch-deposit',
    name: '各机构存款情况统计',
    category: '对公业务',
    subCategory: '存款产品',
    department: '公司金融部',
    description: '广州银行下辖各机构对公及个人客户存款时点余额与年日均统计，支持按支行维度分析',
    catalogId: 'corporate-branch-deposit',
    tableCount: 4,
    recordCount: '100 条+',
    updateFrequency: 'T+1',
    keywords: ['对公', '存款', '机构', '支行', '时点', '年日均', '个人存款', '海珠'],
  },
  {
    id: 'topic-reg-1',
    name: '监管报送数据核对',
    category: '其他',
    department: '合规管理部',
    description: '一表通报送数据质量核对与差异分析，确保监管报送准确性',
    catalogId: 'regulatory-east',
    tableCount: 6,
    recordCount: '30 万+',
    updateFrequency: 'T+1',
    keywords: ['监管', '报送', '数据', '核对', '差异', '质量'],
  },
]
